import { useSearchRefinementToggleButton } from '#/modules/search/components/Toggle/useSearchRefinementToggleButton';
import type { SearchRefinementType } from '#/modules/search/constants/refinements/searchRefinementTypes';
import { useSearchFilterSelectedValue } from '#/modules/search/hooks/filters/useSearchFilterSelectedValue';

export function useSearchFilterToggleButton(facetType: SearchRefinementType) {
  const selectedFilterValue = useSearchFilterSelectedValue(facetType);

  const { holderRef, toggleButton, toggleButtonStatus } =
    useSearchRefinementToggleButton(facetType, selectedFilterValue);

  return { holderRef, toggleButtonStatus, toggleButton };
}
